import {
  type OfferV11,
  type PrescriptionPrescriptionTypeEnum,
} from '@redteclab/api/clients/bully'

import { priceAccessorGetDisplayPrice } from './priceAccessorGetDisplayPrice'
import { priceAccessorGetThirtyDaysLowestPrice } from './priceAccessorGetThirtyDaysLowestPrice'

export const PRODUCT_THIRTY_DAYS_PRICE_TREND = {
  PRICE_DOWN: 'PRICE_DOWN',
  PRICE_NO_CHANGE: 'PRICE_NO_CHANGE',
  PRICE_UP: 'PRICE_UP',
} as const

export type PRODUCT_THIRTY_DAYS_PRICE_TREND =
  (typeof PRODUCT_THIRTY_DAYS_PRICE_TREND)[keyof typeof PRODUCT_THIRTY_DAYS_PRICE_TREND]
export const priceAccessorGetThirtyDaysPriceTrend = (
  offer: OfferV11 | undefined,
  currentPrescriptionType: PrescriptionPrescriptionTypeEnum,
): PRODUCT_THIRTY_DAYS_PRICE_TREND => {
  if (!offer) {
    return PRODUCT_THIRTY_DAYS_PRICE_TREND.PRICE_NO_CHANGE
  }

  const { price: currentPrice = 0 } =
    priceAccessorGetDisplayPrice(offer, currentPrescriptionType) ?? {}
  const { amount: thirtyDaysLowestPrice = 0 } =
    priceAccessorGetThirtyDaysLowestPrice(offer) ?? {}

  if (thirtyDaysLowestPrice > currentPrice) {
    return PRODUCT_THIRTY_DAYS_PRICE_TREND.PRICE_DOWN
  }

  if (thirtyDaysLowestPrice < currentPrice) {
    return PRODUCT_THIRTY_DAYS_PRICE_TREND.PRICE_UP
  }

  return PRODUCT_THIRTY_DAYS_PRICE_TREND.PRICE_NO_CHANGE
}
